import Helper from '@ember/component/helper';
export default class VGet extends Helper {
  willDestroy() {
    if (this.fullPath) {
      this.removeObserver(this.fullPath, this, this.recompute);
    }
    super.willDestroy();
  }
  compute([obj, path, attr]) {
    this.set('observed', obj);
    const fullPath = path && `observed.validations.attrs.${path}.${attr}`;
    if (fullPath !== this.fullPath) {
      if (this.fullPath) {
        this.removeObserver(this.fullPath, this, this.recompute);
      }
      this.fullPath = fullPath;
      if (this.fullPath) {
        const USE_SYNC = false;
        // eslint-disable-next-line ember/no-observers
        this.addObserver(this.fullPath, this, this.recompute, USE_SYNC);
      }
    }
    return this.fullPath && this.get(this.fullPath);
  }
}